import React, { useContext, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { FilialIdContext } from './FilialContext';
import { UsuarioLogadoContext } from './UsuarioLogadoContext';

/**
 * Alinha FilialContext e UsuarioLogadoContext ao JWT (fonte de verdade = Auth).
 */
const SyncAuthContexts = () => {
  const { filialId, usuario, estaAutenticado } = useAuth();
  const { setFilialIdContext } = useContext(FilialIdContext);
  const { setUsuarioLogadoContext } = useContext(UsuarioLogadoContext);

  useEffect(() => {
    if (!estaAutenticado) return;
    if (filialId) {
      setFilialIdContext(String(filialId));
    }
    if (usuario?.login) {
      setUsuarioLogadoContext(usuario.login);
    }
  }, [
    estaAutenticado,
    filialId,
    usuario,
    setFilialIdContext,
    setUsuarioLogadoContext,
  ]);

  return null;
};

export default SyncAuthContexts;
